import { Box } from '@mantine/core';

import { SportybotLogo } from '../sportybot-logo';
import { DesktopNav } from './desktop-nav/desktop-nav';
import { MobileNav } from './mobile-nav/mobile-nav';
import classes from './navigation.module.css';

export function Navigation() {
  return (
    <Box className={classes.container}>
      <SportybotLogo />
      <DesktopNav />
      <MobileNav />
    </Box>
  );
}
